const scrollTop = document.getElementById('scroll__top');

const placeAboveChat = () => {
  const activator = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('.activator');
  const rect = activator?.getBoundingClientRect();
  if (!rect || rect.height === 0) {
    scrollTop.style.removeProperty('--scroll-top-chat-offset');
    delete scrollTop.dataset.chatSide;
    return;
  }

  // Pe telefon butonul trece in coltul opus bulei de chat, deci CSS-ul trebuie
  // sa stie pe ce parte e ea. Latura se citeste, nu se presupune: pozitia bulei
  // e o setare a aplicatiei Inbox si se poate schimba din admin.
  scrollTop.dataset.chatSide = rect.left < window.innerWidth / 2 ? 'left' : 'right';

  if (rect.left < window.innerWidth / 2) {
    scrollTop.style.removeProperty('--scroll-top-chat-offset');
    return;
  }
  scrollTop.style.setProperty('--scroll-top-chat-offset', `${Math.round(window.innerHeight - rect.top + 16)}px`);
};

scrollTop.addEventListener('click', () => {
  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
});

const update = () => {
  const shouldShow = window.scrollY > 300;
  if (shouldShow && !scrollTop.classList.contains('active')) placeAboveChat();
  scrollTop.classList.toggle('active', shouldShow);
};

window.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', placeAboveChat);
update();
